module.exports = __webpack_public_path__ + "static/media/emergency_mgmt.e356921e.png";